var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { apiService } from '../utils/api';
import MdlPaginatorLeft from '../components/MdlPaginatorLeft';
import '../styles/masterListView.css';
import { pillValue } from '../utils/mdlPill';
var entityTypes = [
    { label: 'All Types', value: null },
    { label: 'Journal Entry', value: 'JOURNAL_ENTRY' },
    { label: 'Account', value: 'ACCOUNT' },
    { label: 'Expense', value: 'EXPENSE_ENTRY' },
    { label: 'Savings', value: 'MEMBER_SAVINGS' },
    { label: 'Loan Disbursement', value: 'LOAN_DISBURSEMENT' },
    { label: 'Bank Reconciliation', value: 'BANK_RECONCILIATION' },
];
var actionColors = {
    CREATE: '#4CAF50', UPDATE: '#2196F3', DELETE: '#f44336', APPROVE: '#009688', REVERSE: '#FF9800'
};
var AuditReport = function () {
    var _a = useState([]), entries = _a[0], setEntries = _a[1];
    var _b = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), fromDate = _b[0], setFromDate = _b[1];
    var _c = useState(new Date()), toDate = _c[0], setToDate = _c[1];
    var _d = useState(null), filterType = _d[0], setFilterType = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), searched = _f[0], setSearched = _f[1];
    var _g = useState(''), searchInput = _g[0], setSearchInput = _g[1];
    var _h = useState(''), globalFilter = _h[0], setGlobalFilter = _h[1];
    var _j = useState(0), first = _j[0], setFirst = _j[1];
    var _k = useState(25), rows = _k[0], setRows = _k[1];
    var toast = useRef(null);
    useEffect(function () {
        var debounce = setTimeout(function () { return setGlobalFilter(searchInput); }, 300);
        return function () { return clearTimeout(debounce); };
    }, [searchInput]);
    useEffect(function () {
        setFirst(0);
    }, [globalFilter, entries]);
    var fetchAuditLogs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, from, to, r, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    url = void 0;
                    if (filterType) {
                        url = "/audit-log/by-type?entityType=".concat(filterType);
                    }
                    else {
                        from = fromDate.toISOString().split('T')[0];
                        to = toDate.toISOString().split('T')[0];
                        url = "/audit-log/by-date?from=".concat(from, "&to=").concat(to);
                    }
                    return [4 /*yield*/, apiService.get(url)];
                case 2:
                    r = _c.sent();
                    if (r.success)
                        setEntries(r.data || []);
                    else
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: r.error || 'Failed' });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch audit logs' });
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    setSearched(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var dateTemplate = function (row) {
        var d = new Date(row.performedAt);
        return "".concat(d.toLocaleDateString('en-IN'), " ").concat(d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }));
    };
    var actionTemplate = function (row) { return _jsx(Tag, { value: row.action, style: { backgroundColor: actionColors[row.action] || '#607D8B' } }); };
    var entityTemplate = function (row) { return _jsx("span", __assign({ style: { fontSize: '0.9rem' } }, { children: row.entityType.replace(/_/g, ' ') })); };
    var changeTemplate = function (row) {
        if (row.fieldName) {
            return (_jsxs("div", __assign({ style: { fontSize: '0.85rem' } }, { children: [_jsx("strong", { children: row.fieldName }), ": ", _jsx("span", __assign({ style: { color: '#c62828', textDecoration: 'line-through' } }, { children: row.oldValue || '(empty)' })), ' ', "\u2192 ", _jsx("span", __assign({ style: { color: '#2e7d32' } }, { children: row.newValue || '(empty)' }))] })));
        }
        return _jsx("span", __assign({ style: { fontSize: '0.85rem', color: '#666' } }, { children: row.description || '—' }));
    };
    var term = globalFilter.trim().toLowerCase();
    var filteredEntries = !term ? entries : entries.filter(function (e) {
        return [e.entityType, e.action, e.fieldName, e.oldValue, e.newValue, e.description, String(e.entityId)]
            .some(function (v) { return v === null || v === void 0 ? void 0 : v.toLowerCase().includes(term); });
    });
    return (_jsxs("div", __assign({ className: "card mdl-page" }, { children: [_jsx(Toast, { ref: toast }), _jsx("div", __assign({ className: "mdl-page-header" }, { children: _jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Audit Trail" })), _jsx("p", __assign({ className: "mdl-page-subtitle" }, { children: searched ? "".concat(entries.length, " entr").concat(entries.length === 1 ? 'y' : 'ies') : 'Pick a type or date range, then search' }))] }) })), _jsxs("div", __assign({ className: "mdl-toolbar" }, { children: [_jsxs("span", __assign({ className: "p-input-icon-left mdl-search" }, { children: [_jsx("i", { className: "pi pi-search" }), _jsx(InputText, { placeholder: "Search entity, field or details", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, className: "mdl-search-input" })] })), _jsxs("div", __assign({ className: "mdl-toolbar-filters" }, { children: [_jsx(Dropdown, { value: filterType, options: entityTypes, onChange: function (e) { return setFilterType(e.value); }, placeholder: "Type: All", valueTemplate: pillValue('Type'), className: "mdl-filter-pill".concat(filterType ? ' applied' : '') }), _jsx(Calendar, { value: fromDate, onChange: function (e) { return setFromDate(e.value); }, dateFormat: "dd/mm/yy", placeholder: "From", className: "mdl-date-pill", disabled: !!filterType }), _jsx(Calendar, { value: toDate, onChange: function (e) { return setToDate(e.value); }, dateFormat: "dd/mm/yy", placeholder: "To", className: "mdl-date-pill", disabled: !!filterType }), _jsx(Button, { label: "Search", icon: "pi pi-search", className: "mdl-selection-btn", onClick: fetchAuditLogs, loading: loading })] }))] })), _jsxs(DataTable, __assign({ value: filteredEntries, loading: loading, paginator: true, first: first, rows: rows, onPage: function (e) { setFirst(e.first); setRows(e.rows); }, sortField: "performedAt", sortOrder: -1, className: "p-datatable-sm mdl-table-header mdl-table-footer", paginatorLeft: _jsx(MdlPaginatorLeft, { id: "audit-rows-per-page", first: first, rows: rows, total: filteredEntries.length, options: [25, 50, 100], onRowsChange: function (r) { setRows(r); setFirst(0); } }), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", emptyMessage: !searched ? "Click 'Search' to view the audit trail" : globalFilter ? 'No entries match your search' : 'No audit entries for this filter' }, { children: [_jsx(Column, { field: "performedAt", header: "Date/Time", body: dateTemplate, sortable: true, style: { width: '15%' } }), _jsx(Column, { field: "action", header: "Action", body: actionTemplate, sortable: true, style: { width: '10%' } }), _jsx(Column, { field: "entityType", header: "Entity", body: entityTemplate, sortable: true, style: { width: '12%' } }), _jsx(Column, { field: "entityId", header: "ID", headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '6%' } }), _jsx(Column, { field: "description", header: "Details", body: changeTemplate, style: { width: '35%' } }), _jsx(Column, { field: "performedBy", header: "User ID", headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '8%' } })] }))] })));
};
export default AuditReport;
